import { styled, Dialog } from "@mui/material";
import React from "react";

const BottomDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    margin: 10,
    position: "absolute",
    bottom: 0,
    right: 0,
    width:400
  },
}));

export default BottomDialog;
